import { Component, OnDestroy, OnInit } from '@angular/core';
import {
  IzvestajiClient,
  KpoTableDto,
  ResultOfGetKpoTableResponse,
} from '@kodit/core/data-api';
import { Subscription } from 'rxjs';
import { GodinaRacunaDropdownService } from '@kodit/core/services';
import * as XLSX from 'xlsx';
import { finalize } from 'rxjs/operators';
import { LoaderService } from '../../../../../../shared-ui/src/lib/loader/loader.service';

@Component({
  selector: 'kodit-kpo-knjiga-table',
  templateUrl: './kpo-knjiga-table.component.html',
  styleUrls: ['./kpo-knjiga-table.component.scss'],
})
export class KpoKnjigaTableComponent implements OnInit, OnDestroy {
  /** Props */
  columns: Array<{ field: string; header: string }> = [];
  tableData: KpoTableDto[] | undefined;
  isLoading = true;
  loadingData = [];
  /** Subscriptions */
  private _subs: Subscription = new Subscription();

  constructor(
    private _client: IzvestajiClient,
    private _dropdownService: GodinaRacunaDropdownService,
    private _loaderService: LoaderService,
  ) {
    this.columns = [
      { field: 'datumKnjizenja', header: 'Datum i opis knjiženja' },
      { field: 'iznosRoba', header: 'Od prodaje proizvoda' },
      { field: 'iznosUsluga', header: 'Od izvršenih usluga' },
      { field: 'ukupniPrihodi', header: 'Ukupni prihodi od delatnosti' },
    ];
    this.loadingData = Array.from({ length: 9 }).map((_, i) => i);
  }

  ngOnInit(): void {
    this._loadTable();

    this._subs.add(
      this._dropdownService.getForm().valueChanges.subscribe((res) => {
        this._loadTable();
      })
    );
  }

  exportToExcel() {

    this._loaderService.setShowLoader = true;

    this._subs.add(
      this._client
        .getForTable()
        .pipe(
          finalize(() => {
          this._loaderService.reset();
        }))
        .subscribe((res: ResultOfGetKpoTableResponse) => {
          const workbook = XLSX.utils.book_new();
          const sheetData = [
            this.columns.map((c) => c.header),
            ... res.data?.kpoIzlazniRacunDtoList.map((row) =>
              this.columns.map((col) => {
                if (col.field === 'datumKnjizenja') {
                  return `${row.datumKnjizenja} - ${
                    row.brojFakture ?? 'DNEVNI PAZAR'
                  }`.trim();
                }
                return row[col.field] ?? '';
              })
            ),
          ];

          const worksheet = XLSX.utils.aoa_to_sheet(sheetData);
          XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');

          XLSX.writeFile(workbook, 'KPO.xlsx');
        })
    );
  }

  public exportToPDF() {
    this._loaderService.setShowLoader = true;
    this._subs.add(
      this._client.getKpoPdf()
        .pipe(
          finalize(() => {
            this._loaderService.reset();
          })
        )
        .subscribe((res) => {
        this._downloadPdf(res.data);
      })
    );
  }

  ngOnDestroy(): void {
    this._subs.unsubscribe();
  }

  private _downloadPdf(data: Blob) {
    const blob = new Blob([data], { type: 'application/pdf' });
    const link = document.createElement('a');
    link.download = 'KPO.pdf';
    link.href = window.URL.createObjectURL(blob);
    document.body.appendChild(link);

    link.click();
    document.body.removeChild(link);
  }

  private _loadTable() {
    this.isLoading = true;
    this._subs.add(
      this._client
        .getForTable(5)
        .pipe(
          finalize(() => {
            this.isLoading = false;
          })
        )
        .subscribe((res) => {
          this.tableData = res.data?.kpoIzlazniRacunDtoList;
        })
    );
  }
}
